<template>
  <div>
    <div style="padding-top: 25px">
      <p class="navadno-besedilo">
        Zbirka številnih uporabnih in zanimivih povezav, ki vas bodo preusmerile do informativnih
        in zabavnih vsebin.
      </p>
    </div>
    <div style="padding-top: 20px">
      <p class="navadno-besedilo">
        Bi želeli naše informativne vsebine kar v svoj elektronski predal? Prijavite se na novice!
      </p>
      <div>
        <el-input placeholder="" v-model="emailNaslov" class="velikost-vnosnega-polja">
        </el-input>
      </div>
      <div style="padding-top: 10px">
        <el-checkbox v-model="podanoSogasje">
        </el-checkbox>
        <b class="primarna-barva">
          DA,
        </b>želim prejemati obvestila o informativnih vsebinah ter se strinjam s splošnimi pogoji, ki so dostopna
        <a :href="splosniPogoji" target="_blank" class="primarna-barva">
          tukaj</a>.
      </div>
      <div style="padding-top: 30px">
        <el-button class="gumb-potrdi">
          PRIJAVI ME NA NOVICE
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {povezave} from './../../../../../assets/js/Povezave/povezave'
import {Input, Button, Checkbox} from 'element-ui'

export default {
  name: 'InformativneVsebine',
  data () {
    return {
      clientAgent: null,
      emailNaslov: '',
      podanoSogasje: false,
      splosniPogoji: ''
    }
  },
  components: {
    [Button.name]: Button,
    [Input.name]: Input,
    [Checkbox.name]: Checkbox
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.splosniPogoji = povezave.BASE_URL_SPLOSNI_POGOJI
  },
  methods: {}
}
</script>

<style scoped>
.velikost-vnosnega-polja {
  width: 330px;
}

@media only screen and (max-width: 650px) {
  .velikost-vnosnega-polja {
    width: 100%;
  }

  .gumb-potrdi {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/UporabniskiKoticek/UporabneStrani/InformativneVsebine.vue